import client from "./client";

export const select_problem = ({ solved_problems, solved_domains, seq_no }) =>
  client.post("/diagnosis/api/problem/select_problem", {
    solved_problems,
    solved_domains,
    seq_no,
  });
export const ans_check = ({ problem_id, ansinput }) =>
  client.post("/diagnosis/api/problem/ans_check", {
    problem_id,
    ansinput,
  });
